import React from 'react';
import LogoHeader from '../IntroStep/LogoHeader';
import TutorialCard from './TutorialCard';
import './TutorialStep.css';

interface TutorialStepProps {
  onComplete: () => void;
}

const TutorialStep: React.FC<TutorialStepProps> = ({ onComplete }) => {
  return (
    <div className="tutorial-step">
      <LogoHeader />
      <div className="tutorial-step-body">
        <div className="tutorial-step-backdrop" />
        <TutorialCard onAgree={onComplete} />
      </div>
    </div>
  );
};

export default TutorialStep;
